

export const initialState = {
  loading: false,
  historyData:[],
  total:0,
};
